/*
 *
 * ComboBox constants
 *
 */

export const LOAD_OPTIONS = 'claris-vnext/AdvancedForm/ComboBoxTextInput/LOAD_OPTIONS';
export const ADD_NEW_OPTION = 'claris-vnext/AdvancedForm/ComboBoxTextInput/ADD_NEW_OPTION';
